import React from "react";

import "./StatusBadge.css";

interface StatusBadgeProps {
	value: string;
	label: string;
}

export const StatusBadge: React.FunctionComponent<StatusBadgeProps> = ({
	value,
	label
}) => <div className={`status-badge status-badge--${value}`}>{label}</div>;
